import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const EMOJI_RE = /^\p{Extended_Pictographic}️?(⃣|(‍\p{Extended_Pictographic}️?)*)$/u

export type IndustryFormData = {
  name_en: string
  name_es: string
  emoji: string
}

type IndustryFormFieldsProps<T extends IndustryFormData> = {
  data: T
  errors: Partial<Record<keyof T, string>>
  setData: <K extends keyof T>(key: K, value: T[K]) => void
}

export function IndustryFormFields<T extends IndustryFormData>({
  data,
  errors,
  setData,
}: IndustryFormFieldsProps<T>) {
  const err = (key: keyof T) => errors[key]
  const emojiError = data.emoji && !EMOJI_RE.test(data.emoji) ? 'Must be an emoji' : undefined

  return (
    <Card>
      <CardHeader>
        <CardTitle>Industry</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-5 sm:grid-cols-[1fr_1fr_120px]">
        <div className="space-y-1.5">
          <Label htmlFor="name_en">Name (English)</Label>
          <Input
            id="name_en"
            value={data.name_en}
            autoFocus
            onChange={(e) => setData('name_en' as keyof T, e.target.value as T[keyof T])}
          />
          {err('name_en' as keyof T) && (
            <p className="text-xs text-destructive">{err('name_en' as keyof T)}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="name_es">Name (Español)</Label>
          <Input
            id="name_es"
            value={data.name_es}
            onChange={(e) => setData('name_es' as keyof T, e.target.value as T[keyof T])}
          />
          {err('name_es' as keyof T) && (
            <p className="text-xs text-destructive">{err('name_es' as keyof T)}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="emoji">Emoji</Label>
          <Input
            id="emoji"
            value={data.emoji}
            onChange={(e) => setData('emoji' as keyof T, e.target.value as T[keyof T])}
          />
          {(emojiError || err('emoji' as keyof T)) && (
            <p className="text-xs text-destructive">{emojiError ?? err('emoji' as keyof T)}</p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
